export const sleep = (ms: number): Promise<void> => new Promise((r) => setTimeout(r, ms));

/** "2026-06-17" → "17/06/2026" */
export const fmtDate = (iso?: string): string => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

export const fmtDist = (m: number): string => (m >= 1000 ? (m / 1000).toFixed(1) + ' km' : Math.round(m) + ' m');

export const fmtDur = (s: number): string => {
  const m = Math.round(s / 60);
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}min` : `${m} min`;
};
